import { render, staticRenderFns } from "./WeeklyAvailability.vue?vue&type=template&id=60953413&scoped=true&"
import script from "./WeeklyAvailability.vue?vue&type=script&lang=js&"
export * from "./WeeklyAvailability.vue?vue&type=script&lang=js&"
import style0 from "./WeeklyAvailability.vue?vue&type=style&index=0&id=60953413&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60953413",
  null
  
)

export default component.exports